module.exports = __webpack_public_path__ + "img/queue.a1fb7605.svg";